
// Modal Swiper
modalSwiper(document.querySelector('.hokusei1'));
modalSwiper(document.querySelector('.hokusei2'));
modalSwiper(document.querySelector('.hokusei3'));
modalSwiper(document.querySelector('.hokusei4'));
modalSwiper(document.querySelector('.chunansei1'));
modalSwiper(document.querySelector('.chunansei2'));
modalSwiper(document.querySelector('.chunansei3'));
modalSwiper(document.querySelector('.chunansei4'));
modalSwiper(document.querySelector('.chunansei5'));
modalSwiper(document.querySelector('.chunansei6'));
modalSwiper(document.querySelector('.chunansei7'));
modalSwiper(document.querySelector('.iseshima1'));
modalSwiper(document.querySelector('.iseshima2'));
modalSwiper(document.querySelector('.iseshima3'));
modalSwiper(document.querySelector('.iseshima4'));
modalSwiper(document.querySelector('.iseshima5'));
modalSwiper(document.querySelector('.higashikishu1'));
modalSwiper(document.querySelector('.higashikishu2'));
modalSwiper(document.querySelector('.higashikishu3'));
modalSwiper(document.querySelector('.higashikishu4'));
function modalSwiper(container) {
    if (!container) return;
    
    new Swiper(container, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      speed: 1000,
      loop: true,
      effect: 'fade'
    });
};

// モーダルオープン
document.querySelectorAll('.modal_open').forEach(function(modal_open){
  modal_open.addEventListener('click',function(){
    this.nextElementSibling.classList.add('is-visible');
    document.querySelector('body').classList.add('fixed');
    document.querySelector('.p-experience__top').classList.add('is-hidden');
  });
});
// モーダルクローズ
document.querySelectorAll('.modal_close').forEach(function(modal_close){
  modal_close.addEventListener('click',function(){
    this.closest('.p-modal').classList.remove('is-visible');
    document.querySelector('body').classList.remove('fixed');
    document.querySelector('.p-experience__top').classList.remove('is-hidden');
  });
});